function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "am0y2546wa",
  x1: "-.003%",
  x2: "99.999%",
  y1: "49.968%",
  y2: "49.968%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#2CA77B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1.82%",
  stopColor: "#2CA77B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "31.51%",
  stopColor: "#207E5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "77.76%",
  stopColor: "#0E4433"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.95%",
  stopColor: "#072D22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#072D22"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "972qdrmtub",
  x1: "-.002%",
  x2: "100.001%",
  y1: "50.002%",
  y2: "50.002%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3B9F7B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".495%",
  stopColor: "#3B9F7B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25.84%",
  stopColor: "#2C7F62"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "75.95%",
  stopColor: "#114434"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.95%",
  stopColor: "#072D22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#072D22"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#234141",
  fillRule: "nonzero",
  d: "M127.241 10.158c-2.787-2.574-6.833-4.09-11.144-4.09-7.96 0-13.733 5.608-13.733 14.182 0 8.707 5.972 14.38 13.733 14.38 2.454 0 4.245-.264 5.838-.922V21.834h6.765v15.765c-3.117 1.914-7.894 2.901-12.734 2.901-12.27 0-20.566-7.98-20.566-20.25C95.4 8.243 104.09 0 115.764 0c4.445 0 8.292 1.055 11.474 2.97v7.188h.003zM142.461 39.6H135.9V12.803c3.182-1.782 7.291-2.903 11.465-2.903 2.055 0 3.646.198 5.635.727v6.336c-1.858-.727-3.913-.923-5.635-.923-1.986 0-3.58.396-4.904.923V39.6zM176.692 22.456c-.13-4.56-2.324-7.073-6.459-7.073-3.681 0-6.395 2.644-7.235 7.073h13.694zm-13.89 4.23v.133c.387 5.223 4.78 8.065 9.237 8.065 3.941 0 6.783-.924 9.628-2.842v5.75c-2.584 1.852-6.396 2.708-10.08 2.708-8.916 0-14.987-5.817-14.987-15.07 0-9.319 5.944-15.53 13.827-15.53 8.334 0 12.273 5.486 12.273 13.482v3.307h-19.898v-.003zM208.192 22.456c-.13-4.56-2.326-7.073-6.462-7.073-3.68 0-6.395 2.644-7.234 7.073h13.696zm-13.89 4.23v.133c.387 5.223 4.78 8.065 9.24 8.065 3.941 0 6.783-.924 9.625-2.842v5.75c-2.584 1.852-6.396 2.708-10.08 2.708-8.916 0-14.987-5.817-14.987-15.07 0-9.319 5.944-15.53 13.827-15.53 8.334 0 12.273 5.486 12.273 13.482v3.307h-19.898v-.003zM221.4 12.39c4.026-1.574 8.963-2.49 13.185-2.49 7.34 0 12.015 2.82 12.015 11.015V39.6h-6.365V21.502c0-4.193-2.598-5.702-6.171-5.702-2.272 0-4.547.326-6.237.851v22.943H221.4V12.39zM273.89 22.456c-.13-4.56-2.326-7.073-6.461-7.073-3.68 0-6.395 2.644-7.234 7.073h13.695zm-13.889 4.23v.133c.388 5.223 4.78 8.065 9.24 8.065 3.94 0 6.782-.924 9.623-2.842v5.75c-2.584 1.852-6.395 2.708-10.078 2.708-8.915 0-14.986-5.817-14.986-15.07 0-9.319 5.943-15.53 13.825-15.53 8.334 0 12.275 5.486 12.275 13.482v3.307h-19.899v-.003zM297.643 33.489L305.686 10.8 312.3 10.8 296.737 51.3 290.445 51.3 294.466 40.899 282.6 10.8 289.475 10.8zM334.19 22.456c-.13-4.56-2.326-7.073-6.461-7.073-3.68 0-6.395 2.644-7.234 7.073h13.695zm-13.889 4.23v.133c.388 5.223 4.78 8.065 9.24 8.065 3.94 0 6.782-.924 9.623-2.842v5.75c-2.584 1.852-6.395 2.708-10.078 2.708-8.915 0-14.986-5.817-14.986-15.07 0-9.319 5.943-15.53 13.825-15.53 8.334 0 12.275 5.486 12.275 13.482v3.307h-19.899v-.003zM100.8 49.5L100.8 52.356 105.494 52.356 105.494 64.8 108.703 64.8 108.703 52.356 113.4 52.356 113.4 49.5zM118.8 49.5L118.8 64.8 128.7 64.8 128.7 61.944 122.016 61.944 122.016 58.515 128.007 58.515 128.007 55.709 122.016 55.709 122.016 52.356 128.547 52.356 128.547 49.5zM145.535 54.148c-1-1.003-2.472-1.637-4.26-1.637-2.815 0-4.654 2.082-4.654 5.09 0 3.086 1.999 5.091 4.787 5.091 1.789 0 3.076-.526 4.392-1.608v3.456c-1.447.871-2.945 1.16-4.526 1.16-4.89 0-8.074-3.325-8.074-8.101 0-4.802 3.315-8.099 8.074-8.099 1.581 0 3 .317 4.261 1.054v3.594zM162.355 49.5L162.355 55.709 155.373 55.709 155.373 49.5 152.1 49.5 152.1 64.8 155.373 64.8 155.373 58.594 162.355 58.594 162.355 64.8 165.6 64.8 165.6 49.5zM182.22 49.5L182.22 59.804 175.235 49.5 171.9 49.5 171.9 64.8 175.08 64.8 175.08 54.627 182.273 64.8 185.4 64.8 185.4 49.5zM198.9 52.508c-2.674 0-4.691 2.005-4.691 5.09 0 3.089 2.017 5.091 4.691 5.091s4.691-2.005 4.691-5.09c0-3.086-2.017-5.091-4.691-5.091m0-3.008c4.507 0 8.1 3.325 8.1 8.099 0 4.776-3.59 8.101-8.1 8.101-4.507 0-8.1-3.325-8.1-8.101 0-4.774 3.59-8.099 8.1-8.099M212.4 49.5L212.4 64.8 221.4 64.8 221.4 61.944 215.573 61.944 215.573 49.5z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#234141",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.11 3.2c-2.64 0-4.634 1.962-4.634 4.978 0 3.02 1.993 4.978 4.634 4.978 2.64 0 4.634-1.961 4.634-4.978 0-3.016-1.993-4.977-4.634-4.977m0-2.941c4.451 0 8 3.25 8 7.918 0 4.67-3.546 7.921-8 7.921-4.455 0-8-3.25-8-7.92 0-4.668 3.545-7.92 8-7.92M33.48 4.826c-1.088-1.005-2.72-1.65-4.452-1.65-2.848 0-4.79 1.986-4.79 5.005 0 3.123 2.046 5.106 4.79 5.106.698 0 1.37-.076 1.814-.257V8.748h3.21v6.19c-1.217.776-3.264 1.161-5.075 1.161-4.891 0-8.104-3.044-8.104-7.92 0-4.67 3.316-7.92 7.976-7.92 1.813 0 3.392.389 4.633 1.163v3.404h-.002z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000) translate(225.000000, 49.500000)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#234141",
  fillRule: "nonzero",
  d: "M274.461 49.5L270.924 56.016 267.311 49.5 263.7 49.5 269.235 59.107 269.235 64.8 272.511 64.8 272.511 59.107 278.1 49.5zM345.388 17.1L344.012 17.1 344.012 11.976 342 11.976 342 10.8 347.4 10.8 347.4 11.976 345.388 11.976zM354.67 10.8L353.268 15.413 351.822 10.8 350.148 10.8 349.2 17.1 350.549 17.1 351.223 12.697 352.602 17.1 353.864 17.1 355.255 12.697 355.929 17.1 357.3 17.1 356.343 10.8z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#am0y2546wa)",
  fillRule: "nonzero",
  d: "M0 33.3h19.297c4.73-9.054 14.166-15.237 25.042-15.237 10.878 0 20.301 6.183 25.033 15.237h.828V7.937C62.82 2.927 53.921 0 44.339 0 23.356 0 5.664 14.053 0 33.3z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M.237.255H1.237V1.255H.237zM51.435.255H70.844V1.255H51.435z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000) translate(18.000000, 33.300000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#972qdrmtub)",
  fillRule: "nonzero",
  d: "M70.843.255H51.435c-4.76 8.91-14.243 14.996-25.187 14.996-10.939 0-20.419-6.088-25.179-14.996H.237v24.959c7.426 4.934 16.378 7.814 26.01 7.814C47.353 33.028 65.15 19.2 70.844.255z",
  transform: "translate(-178.000000, -168.000000) translate(178.000000, 168.000000) translate(18.000000, 33.300000)"
})))));

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 25 450 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e6cdd759.svg";
export { ForwardRef as ReactComponent };